export default __webpack_public_path__ + "static/survey-results-sample-light-mode-d667b74ed41c4465df4ba18f89ab365c.png";